

export enum KalturaCuePointStatus {
    deleted=2,
	handled=3,
	pending=4,
	ready=1
}